module.exports = __webpack_public_path__ + "static/spanish-bread-5b44e514117842b9006eed3b12bae281.jpg";